import { createSlice } from '@reduxjs/toolkit'
import { HTTP_STATUS } from '../../constants/httpStatus'
import { ALGORAND, ALGORAND_MAIN_NET, ALGORAND_TEST_NET, availableNetworks, RIPPLE } from '../../constants/network'
import { asyncRequest } from '../services'

const namespace = "network"

export const getLastNetwork = asyncRequest(`${namespace}/getLastNetwork`, '/accounts/user/', 'get')


const lastNetwork = localStorage.getItem('last-network')
const lastNetworkAvailableOptions = ['algorand_mainnet', 'algorand_testnet', 'xrp_mainnet', 'xrp_testnet']

const lastNetworkOptions = {
  'algorand_mainnet': availableNetworks[0],
  'algorand_testnet': availableNetworks[1],
  'xrp_mainnet': availableNetworks[3],
  'xrp_testnet': availableNetworks[2]
}

const test = {
  'algorand_mainnet': availableNetworks[0],
  'algorand_testnet': availableNetworks[1],
  'xrp_mainnet': availableNetworks[3],
  'xrp_testnet': availableNetworks[2],
  [ALGORAND]: 'ALGO'
}



const DEFAULT = { status: null, data: null, error: null }

const networkSlice = createSlice({
  name: 'network',
  initialState: {
    network: lastNetworkAvailableOptions.includes(lastNetwork)
      ? (lastNetwork.split('_')[0] === ALGORAND.toLowerCase() ? ALGORAND : RIPPLE)
      : RIPPLE
    ,
    networkType: ALGORAND_TEST_NET,
    setNet: DEFAULT,
    lastNetwork: { 
      ...DEFAULT, 
      data: lastNetworkAvailableOptions.includes(lastNetwork)
        ? lastNetworkOptions[lastNetwork] 
        : availableNetworks[3] 
    }
  },
  reducers: {
    toggleNetwork(state) {
        if (state.network === ALGORAND) {
            state.network = RIPPLE
        } else if (state.network === RIPPLE) {
            state.network = ALGORAND
        }
    },
    toggleNetworkType(state) {
      if (state.networkType === ALGORAND_TEST_NET) {
          state.networkType = ALGORAND_MAIN_NET
      } else if (state.networkType === ALGORAND_MAIN_NET) {
          state.networkType = ALGORAND_TEST_NET
      }
    },
    setNetwork(state, { payload }) {
      state.network = payload
    }
  },
  extraReducers: {
    [getLastNetwork.pending](state) {
      state.lastNetwork.status = HTTP_STATUS.PENDING
    },
    [getLastNetwork.fulfilled](state, { payload }) {
      state.lastNetwork.status = HTTP_STATUS.FULFILLED

      switch(payload?.net) {
        case 'algorand_mainnet':
            state.lastNetwork.data = availableNetworks[0]
            state.network = ALGORAND
            break
        case 'algorand_testnet':
            state.lastNetwork.data = availableNetworks[1]
            state.network = ALGORAND
            break
        case 'xrp_mainnet':
            state.lastNetwork.data = availableNetworks[3]
            state.network = RIPPLE
            break
        case 'xrp_testnet':
            state.lastNetwork.data = availableNetworks[2]
            state.network = RIPPLE
            break
        default:
            break
      }
    },
    [getLastNetwork.rejected](state, { payload }) {
      state.lastNetwork.status = HTTP_STATUS.REJECTED
      state.lastNetwork.error = payload
    }
  }
})

export const { toggleNetwork, toggleNetworkType, setNetwork } = networkSlice.actions

export default networkSlice.reducer
